/*Wiz Custom*/
document.addEventListener('DOMContentLoaded', function() {
  const wearWith = document.querySelector('.js-product-buy');
  if (wearWith) {
    const wearWithBtn = wearWith.querySelector('.js-product-buy__btn');
    const wearWithContent = wearWith.querySelector('.js-product-buy__content');
    const wearWithClose = wearWith.querySelector('.js-product-buy__close');
    if (window.innerWidth < 990) {
      wearWithBtn.addEventListener('click', function() {
        wearListHeight = wearWithContent.querySelector('.product-buy-with__list__container').offsetHeight;
        if (!wearWithContent.classList.contains('is-active')) {
          wearWithContent.style.maxHeight = wearListHeight + 'px';
        } else {
          wearWithContent.style.maxHeight = '0';
        }
        wearWithBtn.classList.toggle('is-active');
        wearWithContent.classList.toggle('is-active');
      });
    } else {
      wearWithBtn.addEventListener('mouseenter', function() {
        wearWithBtn.classList.add('is-active');
        wearWithContent.classList.add('is-active');
      });
    }
    wearWithClose.addEventListener('click', function() {
      wearWithBtn.classList.remove('is-active');
      wearWithContent.classList.remove('is-active');
    });
  }
  if (window.innerWidth < 990) {
    $accordeons = document.querySelectorAll('.footer-block--menu');
    if ($accordeons.length > 0) {
      $accordeons.forEach(function ($accordeon) {
        $title = $accordeon.querySelector('.footer-block__heading');
        $title.addEventListener('click', function () {
          $wrapper = $accordeon.querySelector('.footer-block__details-content__wrapper');
          $content = $accordeon.querySelector('.footer-block__details-content');
          $accordeon.classList.toggle('is-open');
          if ($accordeon.classList.contains('is-open')) {
            $wrapper.style.maxHeight = $content.scrollHeight + 'px';
          } else {
            $wrapper.style.maxHeight = '0';
          }
        });
      });
    }
  }
});